'use strict';
import { cn_element } from '../model/cn_element';
import { cn_camera } from './cn_camera';
import { cn_svg_map } from './cn_svg_map';
import { cn_pastille } from './cn_pastille';
import { cn_element_type_input } from './cn_inputs';

export class cn_type_pastille extends cn_pastille {
    //***********************************************************************************
    /**
     * Constructor
     * @param {cn_element[]} elements
     * @param {string} key
     * @param {function} get_choices
     * @param {string} transaction_name
     * @param {cn_svg_map} map
     */
    constructor(elements, key, get_choices, transaction_name, map) {
        super();

        this._elements = elements;
        this._key = key;
        this._map = map;
        this._get_choices = get_choices;
        this._transaction_name = transaction_name;
        this.rectangle = [30, 30];
        this.null_element_type = null;
        this.checkbox_label = "";
        this.checkbox_status = true;
    }

    //***********************************************************************************
    //**** Force one measure
    //***********************************************************************************
    /**
     *
     * @param {cn_camera} camera
     * @returns
     */
    draw(camera) {

        if (!this.rectangle)
            this.rectangle = [camera.thumb_size, camera.thumb_size];

        const element_type = this._elements[0][this._key];
        if (element_type)
            this.label = element_type.draw_svg_icon(this.rectangle[0], this.rectangle[1]);
        else
            this.label = "texture_.jpg";

        this.incoherent = this._elements.some(element => element[this._key] != element_type);

        return super.draw(camera);
    }

    //***********************************************************************************
    //**** Called on clicking
    //***********************************************************************************
    clicked() {
        this.call("clicked");
        const input = new cn_element_type_input('Choix du type');
        input.choices = this._get_choices();
        if (this.null_element_type) {
            this.null_element_type.is_null = true;
            input.choices = [this.null_element_type, ...input.choices];
        }
        input.selection = [];
        this._elements.forEach(element => {
            const index = (this.null_element_type && !element[this._key]) ? 0 : input.choices.indexOf(element[this._key]);
            if (index >= 0 && input.selection.indexOf(index) < 0) input.selection.push(index);
        });

        if (this.checkbox_label != "") {
            input.checkbox_label = this.checkbox_label;
            input.checkbox_status = this.checkbox_status;
        }

        input.callback = () => {
            const index = input.selection[0];
            if (index < 0 || index > input.choices.length) return;
            let new_type = input.choices[index];
            if (new_type == this.null_element_type) new_type = null;
            this._map._building.transaction_manager.push_transaction(this._transaction_name);
            this._elements.forEach(element => {
                this._map._building.transaction_manager.push_item_set(element, this._key);
                element[this._key] = new_type;
            });
            if (this.checkbox_label != "")
                this.checkbox_status = input.checkbox_status;

            this.call("post_input", input);

            this.call("callback");
            this._map._scene.update();
            this._map._scene.update_deep();
            this.call('type_changed');
            this._map.refresh();
        }

        this.call("pre_input", input);
        this._map.call('element_type_input', input);
    }
}

